// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2jQ2d","colCheckbox":"styles_colCheckbox__2Sux7"};